import { FeaturesContext } from './context';
import FeatureProvider from './provider';
import useFeatures from './hooks/features';

const FeatureConsumer = FeaturesContext.Consumer;

export { FeaturesContext, FeatureConsumer, FeatureProvider, useFeatures };
